import { Link } from "react-router-dom"

export const Navbar = () => {
    return <div className="navbar links">
        <Link to={"/"}>Home</Link>
        <Link to={"/login"}>Login</Link>
        <Link to={"/transit"}>Transits</Link>        
        <Link to={"new-chart/new-chart"}>New Chart</Link>
    </div>
}